/**
 * AWS Amplify configuration for Cognito authentication.
 *
 * These values are injected at build time from environment variables.
 * Set them before building:
 *   REACT_APP_USER_POOL_ID
 *   REACT_APP_USER_POOL_CLIENT_ID
 *   REACT_APP_AWS_REGION         (default: us-east-1)
 *   REACT_APP_COGNITO_DOMAIN     (e.g. genai-roleplay-507044083752.auth.us-east-1.amazoncognito.com)
 *   REACT_APP_OAUTH_REDIRECT_URL (e.g. https://roleplay.omaraws.people.aws.dev/callback)
 *
 * The hosted-UI/OAuth section is used for Federate (Midway) federation.
 * When the OAuth env vars are unset, the app falls back to direct
 * username/password Cognito auth (useful for local development).
 */

const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN || '';
const redirectUrl =
  process.env.REACT_APP_OAUTH_REDIRECT_URL ||
  (typeof window !== 'undefined' ? `${window.location.origin}/callback` : '');
const signOutUrl =
  process.env.REACT_APP_OAUTH_SIGNOUT_URL ||
  (typeof window !== 'undefined' ? `${window.location.origin}/login` : '');

export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID || '',
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '',
      loginWith: {
        email: true,
        username: true,
        ...(cognitoDomain
          ? {
              oauth: {
                domain: cognitoDomain,
                scopes: ['openid', 'aws.cognito.signin.user.admin'],
                redirectSignIn: [redirectUrl],
                redirectSignOut: [signOutUrl],
                responseType: 'code' as const,
              },
            }
          : {}),
      },
    },
  },
};

// Validate configuration
export function validateAwsConfig(): boolean {
  if (!awsConfig.Auth.Cognito.userPoolId) {
    console.warn('REACT_APP_USER_POOL_ID is not set');
    return false;
  }
  if (!awsConfig.Auth.Cognito.userPoolClientId) {
    console.warn('REACT_APP_USER_POOL_CLIENT_ID is not set');
    return false;
  }
  return true;
}

export const isFederationEnabled = !!cognitoDomain;
